<template>
  <div class="svg25ar"
       ref="svgTarget">
    <svg height="550"
         preserveAspectRatio="xMidYMid meet"
         width="550"
         xmlns="http://www.w3.org/2000/svg">
      <g id="group1">
        <circle cx="275"
                cy="275"
                fill="white"
                r="250"
                stroke="black"
                stroke-width="0.3" />
        <circle cx="275"
                cy="275"
                fill="white"
                r="225"
                stroke="black"
                stroke-width="0.3" />
        <circle cx="275"
                cy="275"
                fill="white"
                r="200"
                stroke="black"
                stroke-width="0.3" />
        <circle cx="275"
                cy="275"
                fill="white"
                r="175"
                stroke="black"
                stroke-width="0.3" />
        <circle cx="275"
                cy="275"
                fill="white"
                r="150"
                stroke="black"
                stroke-width="0.3" />
        <circle cx="275"
                cy="275"
                fill="white"
                r="125"
                stroke="black"
                stroke-width="0.3" />
        <circle cx="275"
                cy="275"
                fill="black"
                r="100"
                stroke="white"
                stroke-width="0.3" />
        <circle cx="275"
                cy="275"
                fill="black"
                r="75"
                stroke="white"
                stroke-width="0.3" />
        <circle cx="275"
                cy="275"
                fill="black"
                r="50"
                stroke="white"
                stroke-width="0.3" />
        <circle cx="275"
                cy="275"
                fill="black"
                r="25"
                stroke="white"
                stroke-width="0.3" />
        <circle cx="275"
                cy="275"
                fill="black"
                r="12.5"
                stroke="white"
                stroke-width="0.3" />
        <text fill="black"
              font-size="12"
              stroke-width="0"
              x="271"
              y="42">
          1
        </text>
        <text fill="black"
              font-size="12"
              stroke-width="0"
              x="271"
              y="517">
          1
        </text>
        <text fill="black"
              font-size="12"
              stroke-width="0"
              x="508"
              y="278">
          1
        </text>
        <text fill="black"
              font-size="12"
              stroke-width="0"
              x="35"
              y="278">
          1
        </text>
        <text fill="black"
              font-size="12"
              stroke-width="0"
              x="271"
              y="67">
          2
        </text>
        <text fill="black"
              font-size="12"
              stroke-width="0"
              x="271"
              y="492">
          2
        </text>
        <text fill="black"
              font-size="12"
              stroke-width="0"
              x="483"
              y="278">
          2
        </text>
        <text fill="black"
              font-size="12"
              stroke-width="0"
              x="60"
              y="278">
          2
        </text>
        <text fill="black"
              font-size="12"
              stroke-width="0"
              x="271"
              y="92">
          3
        </text>
        <text fill="black"
              font-size="12"
              stroke-width="0"
              x="271"
              y="467">
          3
        </text>
        <text fill="black"
              font-size="12"
              stroke-width="0"
              x="458"
              y="278">
          3
        </text>
        <text fill="black"
              font-size="12"
              stroke-width="0"
              x="85"
              y="278">
          3
        </text>
        <text fill="black"
              font-size="12"
              stroke-width="0"
              x="271"
              y="117">
          4
        </text>
        <text fill="black"
              font-size="12"
              stroke-width="0"
              x="271"
              y="442">
          4
        </text>
        <text fill="black"
              font-size="12"
              stroke-width="0"
              x="433"
              y="278">
          4
        </text>
        <text fill="black"
              font-size="12"
              stroke-width="0"
              x="110"
              y="278">
          4
        </text>
        <text fill="black"
              font-size="12"
              stroke-width="0"
              x="271"
              y="142">
          5
        </text>
        <text fill="black"
              font-size="12"
              stroke-width="0"
              x="271"
              y="417">
          5
        </text>
        <text fill="black"
              font-size="12"
              stroke-width="0"
              x="408"
              y="278">
          5
        </text>
        <text fill="black"
              font-size="12"
              stroke-width="0"
              x="135"
              y="278">
          5
        </text>
        <text fill="black"
              font-size="12"
              stroke-width="0"
              x="271"
              y="167">
          6
        </text>
        <text fill="black"
              font-size="12"
              stroke-width="0"
              x="271"
              y="392">
          6
        </text>
        <text fill="black"
              font-size="12"
              stroke-width="0"
              x="383"
              y="278">
          6
        </text>
        <text fill="black"
              font-size="12"
              stroke-width="0"
              x="160"
              y="278">
          6
        </text>
        <text fill="white"
              font-size="12"
              stroke-width="0"
              x="271"
              y="192">
          7
        </text>
        <text fill="white"
              font-size="12"
              stroke-width="0"
              x="271"
              y="367">
          7
        </text>
        <text fill="white"
              font-size="12"
              stroke-width="0"
              x="358"
              y="278">
          7
        </text>
        <text fill="white"
              font-size="12"
              stroke-width="0"
              x="185"
              y="278">
          7
        </text>
        <text fill="white"
              font-size="12"
              stroke-width="0"
              x="271"
              y="217">
          8
        </text>
        <text fill="white"
              font-size="12"
              stroke-width="0"
              x="271"
              y="342">
          8
        </text>
        <text fill="white"
              font-size="12"
              stroke-width="0"
              x="333"
              y="278">
          8
        </text>
        <text fill="white"
              font-size="12"
              stroke-width="0"
              x="210"
              y="278">
          8
        </text>
        <text fill="white"
              font-size="12"
              stroke-width="0"
              x="271"
              y="242">
          9
        </text>
        <text fill="white"
              font-size="12"
              stroke-width="0"
              x="271"
              y="317">
          9
        </text>
        <text fill="white"
              font-size="12"
              stroke-width="0"
              x="308"
              y="278">
          9
        </text>
        <text fill="white"
              font-size="12"
              stroke-width="0"
              x="235"
              y="278">
          9
        </text>
      </g>
      <g v-for="(item, idx) in dataitem"
         :key="idx">
        <circle v-if="item.x != ''"
                :cx="centerPosition + item.x * 1"
                :cy="centerPosition - item.y * 1"
                :fill="idx + 1 == dataitem.length ? '#FBFE55' : '#A8FDF5'"
                :r="bulletRadius"
                stroke="blank"
                stroke-width="0.3" />
                 <line :x1="centerPosition + item.x * 1-bulletRadius*2"
              :y1="centerPosition - item.y * 1"
              :x2="centerPosition + item.x * 1-bulletRadius"
              :y2="centerPosition - item.y * 1"
              :opacity="(idx+1)/dataitem.length+0.3"
              :stroke="idx + 1 == dataitem.length ? '#FBFE55' : '#A8FDF5'"
              stroke-width=1.5 />
        <line :x1="centerPosition + item.x * 1+bulletRadius*2"
              :y1="centerPosition - item.y * 1"
              :x2="centerPosition + item.x * 1+bulletRadius"
              :y2="centerPosition - item.y * 1"
              :opacity="(idx+1)/dataitem.length+0.3"
              :stroke="idx + 1 == dataitem.length ? '#FBFE55' : '#A8FDF5'"
              stroke-width=1.5 />
        <line :x1="centerPosition + item.x * 1"
              :y1="centerPosition - item.y * 1+bulletRadius*2.5"
              :x2="centerPosition + item.x * 1"
              :y2="centerPosition - item.y * 1+bulletRadius"
              :opacity="(idx+1)/dataitem.length+0.3"
              :stroke="idx + 1 == dataitem.length ? '#FBFE55' : '#A8FDF5'"
              stroke-width=1.5 />
        <line :x1="centerPosition + item.x * 1"
              :y1="centerPosition - item.y * 1-bulletRadius*2.5"
              :x2="centerPosition + item.x * 1"
              :y2="centerPosition - item.y * 1-bulletRadius"
              :opacity="(idx+1)/dataitem.length+0.3"
              :stroke="idx + 1 == dataitem.length ? '#FBFE55' : '#A8FDF5'"
              stroke-width=1.5 />
      </g>
      
    </svg>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 子弹半径
      bulletRadius: 2.8,
      // 中心点
      centerPosition: 275,
      // 靶面直径（0环大小）
      diameter: 500,
      // 初始缩放比率
      initScale: 1,
      // 负margin值 考虑面板大于显示框的情况
      marign: 0,
      zoomSetting: [1, 1, 1, 2.2, 3.8, 5.8],
    }
  },
  watch: {
    lastscore: {
      handler: function (newVal) {
        this.scaleZoom(newVal)
      },
      immediate: true,
    },
  },
  methods: {
    // 设置css原始属性值（放大倍数scale ，偏移量 margin）
    setProperty: function (attribute, val) {
      this.$refs.svgTarget
        ? this.$refs.svgTarget.style.setProperty(attribute, val)
        : ""
    },
    scaleZoom: function (newVal) {
      let idx = 0
      if (newVal == "") {
        idx = 0
      } else {
        idx = Math.floor(newVal / 2)
      }

      this.setProperty("--transScale", this.initScale * this.zoomSetting[idx])
    },
  },
  mounted() {
    const parentContainerHeight = document.getElementsByClassName(
      "targetContainer"
    )[0].clientHeight
    alert(parentContainerHeight)
    // -0.1杜绝1像素问题
    this.initScale = parentContainerHeight / this.diameter - 0.01

    // 考虑面板大于显示框的情况
    // if (parentContainerHeight < this.centerPosition * 2) {
    //   this.margin = (parentContainerHeight - this.centerPosition * 2) / 2 + "px"
    //   this.setProperty("--margin", this.margin)
    //   this.setProperty("--transScale", this.initScale)
    // } else {
    //   this.setProperty("--transScale", this.initScale)
    // }
    this.margin = (parentContainerHeight - this.centerPosition * 2) / 2 + "px"
      this.setProperty("--margin", this.margin)
      this.setProperty("--transScale", this.initScale)
    this.scaleZoom(this.lastscore)
  },
  props: ["dataitem", "lastscore"],
}
</script>
<style lang="less" scoped>
.svg25ar {
  flex: 1;
  display: flex;
  align-items: center;
  --transScale: 1;
  --margin: 0px;
  position: absolute;
  svg {
    transform: scale(var(--transScale));
    margin-top: var(--margin);
  }
}
</style>
